<ng-container *ngIf="otpSent && (!srcProfileReturns?.profiles[0]?.maskedCards || srcProfileReturns?.profiles[0]?.maskedCards?.length === 0) && !loading">

  <ng-container>
    <div class="flex flex-row items-center">
      <p class="mb-0 text-xs sm:text-sm mr-3">
        <img width="84" height="84" src="../../../assets/icons/Icons/visa-checkout.svg" class="mb-2">
      </p>
      <div [class.flex-col]="mobile" [class.flex-row]="!mobile" class="flex items-center mb-2">
        <p class="text-sm pb-0 mb-0">Enter the one-time code sent to:</p>
        <div class="flex flex-row justify-center items-center mr-4"><p class="text-sm font-bold mr-1 ml-1"> {{ emailControl?.value }}</p><p class="underline cursor-pointer" (click)="changeConsumerIdentity()">(Not you?)</p></div>
        <p class="underline mb-0 pb-0 cursor-pointer text-center" (click)="resendOtp()">Resend Code</p>
      </div>
    </div>
    <p class="border-solid border-gray-300" [ngClass]="loading ? 'mb-1' : 'mb-0'" style="border-width: 1px;"></p>
  </ng-container>

  <form [formGroup]="otpForm" class="rounded-0 mt-2 flex flex-wrap flex-col items-start justify-evenly">

    <div class="w-11/12 sm:w-2/5 relative">
      <mat-form-field style="height: 72px; width: 150px;" appearance="outline" class="w-full relative">
        <mat-label>Please enter your 6-digit OTP</mat-label>
        <input
          matInput
          [placeholder]="'Please enter your otp'"
          required
          formControlName="otp"
          [errorStateMatcher]="matcher"
        >
        <mat-error>
          Please enter {{('a valid otp')| lowercase}}.
        </mat-error>
      </mat-form-field>

    </div>
  </form>

  <button
    #continueButtonIdentityForm
    class="text-lg text-white h-10 rounded-lg flex justify-center items-center click-to-pay-background-coral mb-3"
    [ngStyle]="{'background-color': headerColor}"
    (click)="callCompleteIdValidationClicked()"
    [disabled]="identityForm.invalid"
    [ngClass]="mobile ? 'w-11/12' : 'w-36' "
  >
                  <span *ngIf="!loading" class="flex items-center">
                    <strong class="text-xs">Continue</strong>
                  </span>
    <mat-spinner
      *ngIf="loading"
      class="loading-spinner mb-1 mt-1"
      color="primary"
      diameter="20"
    >
    </mat-spinner>
  </button>

</ng-container>

<div class="payment-method-container mat-typography mt-2" *ngIf="loading || srcProfileReturns?.profiles[0]?.maskedCards?.length > 0">

  <ng-container>
    <div class="flex flex-row items-center">
      <p class="mb-0 text-xs sm:text-sm mr-3">
        <img width="84" height="84" src="../../../assets/icons/Icons/visa-checkout.svg" class="mb-2">
      </p>
      <div *ngIf="srcProfileReturns?.profiles[0]?.maskedCards?.length > 0" class="flex flex-row justify-center items-center mr-4"><p class="text-sm font-bold mr-1 ml-1"> {{ emailControl?.value }}</p><p class="underline cursor-pointer" (click)="changeConsumerIdentity()">(Not you?)</p></div>
    </div>
    <p class="border-solid border-gray-300" [ngClass]="loading ? 'mb-1' : 'mb-0'" style="border-width: 1px;"></p>
  </ng-container>

  <ng-container *ngIf="!loading else loadingTemplateRef">
    <div class="flex flex-wrap payment-methods pb-2 mt-1" [ngClass]="mobile ? 'justify-center' : 'justify-start'" *ngIf="paymentMethodsOtherTabsAmount === 1">
      <div class="w-10/12 md:w-15/50 lg:w-16/50 m-1 relative individual-cards" *ngFor="let paymentMethodOther of paymentMethodsOther">
        <ng-container>
          <div class="max-w-sm overflow-hidden box flex justify-center" style="border-radius: 12px;" (click)="callCheckout('EXISTING', paymentMethodOther)" [id]="paymentMethodOther['code'].toLowerCase()">
            <div class="picsum-img-wrapper justify-center items-center side front bg-cover w-11/12 h-full" id="paymentTabFront" #paymentTabFront>
              <img [src]="paymentMethodOther.imgUrl" class="w-full cursor-pointer" [ngStyle]="{'padding': paymentMethodOther.code !== 'CLICK_TO_PAY' ? '8px' : '', 'border-radius': paymentMethodOther.code !== 'CLICK_TO_PAY' ? '12px' : ''}" [alt]="paymentMethodOther['code'].toLowerCase()" id='payment-method-image-other'>
              <div *ngIf="paymentMethodOther.code !== 'CLICK_TO_PAY'" class="text-lg font-bold absolute text-white color-white bottom-0 left-0" style="margin-left: 24px; margin-bottom: 20px;">{{ paymentMethodOther.pan }}</div>
            </div>
          </div>
        </ng-container>
      </div>
    </div>

    <mat-tab-group (selectedTabChange)="onTabChanged($event);" #groupOther [selectedIndex]="selectedIndexOther" *ngIf="paymentMethodsOtherTabsAmount > 1" class="other-tab-group" headerPosition="below">
      <mat-tab style="border-top-left-radius: 0px !important;" #tabOther *ngFor="let paymentMethodOther of paymentMethodsOtherTotalsArr; index as i;" label="O">
        <ng-template mat-tab-label>
          <mat-icon class="z-50" style="height: 12px !important; width: 12px !important; font-size: 12px !important;" #matIconsOther>{{ i === 0 ? 'lens': 'trip_origin'}}</mat-icon>
        </ng-template>
        <div class="flex flex-wrap payment-methods pb-2 mt-1" [ngClass]="mobile ? 'justify-center' : 'justify-start'">
          <div class="payment-navigation-arrows-container-parent" *ngIf="cols > 1">
            <div class="absolute left-0 z-50 payment-navigation-arrows-container" *ngIf="selectedIndexOther > 0">
              <button class="payment-navigation-button" (click)="page($event, 'left', 'button')">
                <mat-icon class="z-50" class="payment-navigation-arrows opacity-75" style="background-color: gray; border-radius: 50%;">arrow_back</mat-icon>
              </button>
            </div>
            <div class="absolute right-0 z-50 payment-navigation-arrows-container" *ngIf="selectedIndexOther < paymentMethodsOtherTabsAmount-1">
              <button class="payment-navigation-button" (click)="page($event, 'right', 'button')">
                <mat-icon class="z-50" class="payment-navigation-arrows opacity-75" style="background-color: gray; border-radius: 50%;">arrow_forward</mat-icon>
              </button>
            </div>
          </div>
          <div class="w-10/12 md:w-15/50 lg:w-16/50 m-1 relative individual-cards" *ngFor="let paymentMethodOtherz of paymentMethodOther">
            <ng-container>
              <div class="max-w-sm overflow-hidden box flex justify-center" style="border-radius: 12px;" (click)="callCheckout('EXISTING', paymentMethodOtherz)" [id]="paymentMethodOtherz['code'].toLowerCase()">
                <div class="picsum-img-wrapper justify-center items-center side front bg-cover w-11/12 h-full" id="paymentTabFront" #paymentTabFront>
                  <img [src]="paymentMethodOtherz.imgUrl" class="w-full cursor-pointer" [ngStyle]="{'padding': paymentMethodOtherz.code !== 'CLICK_TO_PAY' ? '0px' : '', 'border-radius': paymentMethodOtherz.code !== 'CLICK_TO_PAY' ? '6px' : ''}" [alt]="paymentMethodOtherz['code'].toLowerCase()" id='payment-method-image-other'>
                  <div *ngIf="paymentMethodOther.code !== 'CLICK_TO_PAY'" class="text-lg font-bold absolute text-white color-white bottom-0 left-0" style="margin-left: 24px; margin-bottom: 0px;">{{ paymentMethodOtherz.pan }}</div>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
      </mat-tab>
    </mat-tab-group>
  </ng-container>

</div>
<ng-template #loadingTemplateRef>
  <mat-spinner
  color="primary"
  diameter="28"
  >
  </mat-spinner>
</ng-template>
